import $ from 'jquery';
import I18n from 'i18n-js';
function setupCatalogs() {
    // Sweet Alert modal for delete elements
    if ($('.btn-destroy').length) {
        $('.btn-destroy').click('btn-destroy-click', function (event) {
            let element, resource, resourceId, resourceMsg, row, url, authenticityToken;
            element = $(this);
            resource = element.data('resource');
            resourceId = element.data('resource-id');
            resourceMsg = element.data('resource-message');
            url = `/${resource}/${resourceId}`;
            authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;
            swal(resourceMsg, {
                icon: 'warning',
                buttons: {
                    cancel: I18n.t('messages.cancel'),
                    confirm: {
                        text: I18n.t('messages.delete'),
                        closeModal: true
                    }
                }
            }).then(function (isConfirm) {
                if (!isConfirm) {
                    return;
                }
                $('#MyModal').modal('show')
                $.ajax({
                    url: url,
                    data: {authenticity_token: authenticityToken},
                    type: 'DELETE',
                    dataType: 'json',
                    success: function (data) {
                        $('#MyModal').modal('hide')
                        swal({
                            title: I18n.t('messages.done'),
                            text: I18n.t('messages.deleted'),
                            icon: 'success',
                            button: I18n.t('messages.ok')
                        }).then(function () {
                            location.reload()
                        });
                    },
                    error: function (error) {
                        let message = I18n.t('messages.try_again');
                        if (error.responseJSON && error.responseJSON.message) {
                            message = error.responseJSON.message;
                        }
                        swal(I18n.t('messages.error'), message, 'error');
                    }
                });
            });
        });
    }
}
function destroyCatalogs() {
    // $('.btn-destroy').unbind('btn-destroy-click');
    if ($('.btn-destroy').length) {
        $('.btn-destroy').off('btn-destroy-click');
    }
}

document.addEventListener("turbolinks:load", setupCatalogs);
document.addEventListener('turbolinks:before-cache', destroyCatalogs);
